/**
 * D-139 — a name and ONE channel, and the channel they give is how the shop talks to them.
 *
 * Henry, 2026-09-05: "perhaps it's better to offer up name + email or phone. we need one and
 * can be the preferred customer communication route."
 *
 *     name              REQUIRED
 *     email OR phone    AT LEAST ONE — either satisfies it
 *     address           optional
 *
 * ⚠️ WHAT THIS REPLACED, because it is the whole point. Every one of the four doors marked
 * EMAIL required, and the commission door marked phone required as well. So a customer who
 * has a phone number and no email — which in this shop's trade is not unusual — could not
 * send an enquiry at all. Not "was nudged": the browser refused the submit. That is a
 * customer the shop never hears from, and nothing anywhere would have reported it.
 *
 * HTML HAS NO "ONE OF THESE TWO" CONSTRAINT, so this is script, not markup. The honest
 * consequence, stated rather than hidden: with JavaScript off, neither field is natively
 * required and a submission carrying a name and a description but no channel can reach the
 * shop. That is worse than being asked and better than today, where the phone-only customer
 * is turned away — and D-139 ② puts the real constraint in the database, which is where a
 * rule belongs when the client cannot be trusted to hold it.
 *
 * THE PREFERENCE IS RECORDED, NEVER INFERRED (D-139 ①): "it is asking how the customer wants
 * to be reached". One channel given is an answer. BOTH given is not — nobody asked — so this
 * sends an EMPTY preferred_channel rather than picking one, because a guess here is exactly
 * the "texting default" D-139 says must not override a customer who wanted email.
 */
(function () {
  'use strict';

  var EMAIL = '[name="contact[email]"]';
  var PHONE = '[name="contact[phone]"]';

  function val(el) {
    return el && typeof el.value === 'string' ? el.value.trim() : '';
  }

  function wire(form) {
    var email = form.querySelector(EMAIL);
    var phone = form.querySelector(PHONE);
    if (!email || !phone) return;

    var pref = form.querySelector('[name="contact[preferred_channel]"]');
    if (!pref) {
      pref = document.createElement('input');
      pref.type = 'hidden';
      pref.name = 'contact[preferred_channel]';
      form.appendChild(pref);
    }

    // The message names both ways out. "This field is required" on an email box is what
    // sent the phone-only customer away in the first place.
    var MESSAGE = 'Enter an email address or a phone number — either one is enough.';

    function check() {
      var hasEmail = val(email) !== '';
      var hasPhone = val(phone) !== '';

      // Only one of them carries the message, or the browser reports the same fault twice.
      email.setCustomValidity(hasEmail || hasPhone ? '' : MESSAGE);
      phone.setCustomValidity('');

      pref.value = hasEmail && hasPhone ? '' : hasEmail ? 'email' : hasPhone ? 'phone' : '';
      return hasEmail || hasPhone;
    }

    email.addEventListener('input', check);
    phone.addEventListener('input', check);

    form.addEventListener('submit', function (e) {
      if (!check()) {
        e.preventDefault();
        // reportValidity focuses and announces; falling back to focus() keeps older
        // browsers from submitting silently with the fault unexplained.
        if (typeof form.reportValidity === 'function') form.reportValidity();
        else email.focus();
      }
    });

    check();
  }

  function init() {
    var forms = document.querySelectorAll('form');
    for (var i = 0; i < forms.length; i++) wire(forms[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
